module.exports = __webpack_public_path__ + "img/location.caee8676.svg";